import { twMerge } from 'tailwind-merge';

interface TableMenuProps {
  children: React.ReactNode;
  triggerIcon?: React.ReactNode;
  menuPosition?: 'top-start' | 'bottom-start' | 'left-start' | 'right-start';
  menuTrigger?: 'click' | 'hover';
  disabled?: boolean;
  containerClassName?: string;
  menuClassName?: string;
  triggerIconContainerClassName?: string;
  defaultTriggerIconClassName?: string;
  subMenuContainerClassName?: string;
  onClickTrigger?: () => void;
}

export const TableMenu = ({
  children,
  triggerIcon,
  menuPosition = 'top-start',
  menuTrigger = 'click',
  disabled,
  containerClassName,
  menuClassName,
  triggerIconContainerClassName,
  defaultTriggerIconClassName,
  subMenuContainerClassName,
  onClickTrigger,
}: TableMenuProps) => {
  return (
    <div
      className={twMerge(
        'menu menu-default flex justify-center h-full p-0 hover:cursor-default',
        containerClassName,
        disabled &&
          'after:content-[""] after:absolute after:top-0 after:left-0 after:w-full after:h-full after:z-10 after:hover:cursor-not-allowed'
      )}
      data-menu="true"
    >
      <div
        className={twMerge(
          'w-[40px] menu-item',
          menuClassName,
          disabled && 'opacity-50 pointer-events-none'
        )}
        data-menu-item-placement={menuPosition}
        data-menu-item-toggle="dropdown"
        data-menu-item-trigger={menuTrigger}
        onClick={onClickTrigger}
      >
        <div
          className={twMerge(
            'menu-toggle justify-center hover:cursor-pointer',
            triggerIconContainerClassName
          )}
        >
          {triggerIcon || (
            <i
              className={twMerge(
                'ki-filled ki-dots-vertical text-2xl text-gray-78819D',
                defaultTriggerIconClassName
              )}
            />
          )}
        </div>
        <div
          className={twMerge(
            'menu-dropdown w-max py-2',
            menuPosition === 'top-start' && '!-left-10',
            subMenuContainerClassName
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
